module.exports = __webpack_public_path__ + "static/media/Oswald-Regular.077e87c6.ttf";